import { createSelector } from './selectorWrapper'
import { CollectionType, isCollectionType } from '../components/collection/collectionTypes'
import { CollectionDetail, TitleIdToCollections } from '../reducers/collections'
import { simpleSelectors } from './basicState'

export type ICollection = {
  header?: string
  collectionType: CollectionType
  totalEpisodeSize: number
  cardTitleIds: string[]
  refTagPrefix?: string
  index: number
}

export type ISanitizedCollections = (ICollection | null)[]

export const sanitizedCollectionsSelector = createSelector(
  simpleSelectors.pageTitleId,
  simpleSelectors.collections,
  (
    pageTitleID: string,
    titleIdToCollections: TitleIdToCollections
  ): ISanitizedCollections => {
    return sanitizeCollections(titleIdToCollections[pageTitleID])
  }
)

export const sanitizeCollections = (collections: CollectionDetail[] | undefined) => {
  if (!collections) {
    return []
  }

  return collections.map(
    ({ collectionType, titleIds, header, totalCardSize }, index) => {
      const collectionTypeLC = (collectionType || '').toLowerCase()
      if (
        !isCollectionType(collectionTypeLC) ||
        (titleIds || []).length === 0
      ) {
        return null
      }

      return {
        header,
        collectionType: collectionTypeLC,
        totalEpisodeSize: totalCardSize || 0,
        cardTitleIds: titleIds,
        index,
      }
    }
  )
}
